import React from 'react';
import "./sectionAdvancedSecurity.scss";

//Imagens:
import ImgSectionAdvancedSecurity from "../../../../assets/advancedSecurity/sectionAdvancedSecurity.png";
import { useTranslation } from 'react-i18next';

function SectionAdvancedSecurity() {
  const { t } = useTranslation()
  return (
    <div className='container-section-advanced'>
      <div className='texts-section-advanced'>
        <h1>{t("security.title")}</h1>
        <p>{t("security.section_text")}</p>
        <a href="/form" style={{ textDecoration: "none" }}><button id='btn-section-advanced'>{t("buttons.demo_btn_alternative_text_1")}</button></a>
      </div>
      <div className='img-section-advanced'>
        <img src={ImgSectionAdvancedSecurity} alt="" />
      </div>
    </div>
  )
}

export default SectionAdvancedSecurity